import styled, { css } from "styled-components"

const ButtonGroupWrapper = styled.div`
  display: flex;
  border: solid 1px ${({ theme }) => theme.color.secondary04};
  width: fit-content;
  position: relative;
`
const StyledButton = styled.button`
  min-width: 8.2rem;
  height: 3.2rem;
  background-color: transparent;
  font-family: ${({ theme }) => theme.font.family.body};
  font-size: ${({ theme }) => theme.font.size.md};
  font-weight: ${({ theme }) => theme.font.weight.semiBold};
  line-height: 1.75;
  color: ${({ theme }) => theme.color.secondary02};
  border: none;
  border-right: solid 1px ${({ theme }) => theme.color.secondary04};
  cursor: pointer;
  transition: color 0.2s linear;
  outline: none;

  &:last-of-type {
    border-right: none;
  }

  ${({ isActive }) =>
    isActive &&
    css`
      color: ${({ theme }) => theme.color.white};
    `}
`
const StyledBackground = styled.span`
  background: ${({ theme }) => theme.color.main03};
  position: absolute;
  z-index: -1;
  height: 3.2rem;
  width: 0px;
  transition: transform 0.2s linear, width 0.2s linear;

  ${({ backgroundWidth }) =>
    css`
      width: ${backgroundWidth}px;
    `}

  ${({ backgroundPosition }) =>
    css`
      transform: translateX(${backgroundPosition}px);
    `}
`
export { ButtonGroupWrapper, StyledButton, StyledBackground }
